import React from 'react';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import './orDivider.less';

/**
 * Divider with centered text (defaults to "or").
 * Used to separate alternative actions like "Login" OR "Register".
 */
export default function OrDivider({className, textId = 'esl.generic.or', defaultText = 'or'}) {
    const intl = useIntl();
    const dividerClassName = classNames('or-divider', className);
    const text = intl.formatMessage({id: textId, defaultMessage: defaultText});

    return (
        <div className={dividerClassName}>
            <span className="or-divider-line" />
            <span className="or-divider-text">{text}</span>
            <span className="or-divider-line" />
        </div>
    );
}
